import React, { createContext, useState } from 'react'
import i18n from '../i18n'

export const LangContext = createContext()

// eslint-disable-next-line react/prop-types
const LangProvider = ({ children }) => {
  const [lang, setLang] = useState({
    lang: i18n.language,
  })

  //   const changeLang = (newLang) => {
  //     setLang(newLang)
  //   }

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  )
}

export default LangProvider

// export const useLang = () => {
//   return useContext(LangContext)
// }
